import { FC } from 'react';
import { IListItem } from '../types';
import { Description, Link, StyledList, Term } from './List.styles';

const ListItem = ({ heading, link, description, id }: IListItem) => {
  return (
    <>
      <Term id={id}>
        <Link href={link} rel="noreferrer">
          {heading}
        </Link>
      </Term>
      <Description>{description}</Description>
    </>
  );
};

export const List: FC<{ items: IListItem[]; ariaLabelledby?: string }> = ({ items, ariaLabelledby }) => {
  return (
    <StyledList aria-labelledby={ariaLabelledby}>
      {items.map(item => (
        <ListItem key={item.id} {...item} />
      ))}
    </StyledList>
  );
};
